//packages block
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import { OptionsObject, SnackbarKey, useSnackbar, VariantType, WithSnackbarProps } from "notistack";
import { FC } from "react";
//interface block
import { CloseSnackbarProps } from "../../interfaceTypes";

let useSnackbarRef: WithSnackbarProps;

export const SnackbarUtilsConfiguration: FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export const CloseButton: FC<CloseSnackbarProps> = ({ id }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      color="inherit"
      size="small"
      onClick={() => closeSnackbar(id)}
      aria-label='close notification'
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export const Alert = {
  success(message: string) {
    this.toast(message, "success");
  },
  warning(message: string, options?: OptionsObject) {
    this.toast(message, "warning", options);
  },
  info(message: string, options?: OptionsObject) {
    this.toast(message, "info", options);
  },
  error(message: string) {
    this.toast(message, "error");
  },
  close(key: SnackbarKey) {
    useSnackbarRef.closeSnackbar(key);
  },
  toast(message: string, variant: VariantType = "default", options?: OptionsObject) {
    useSnackbarRef.enqueueSnackbar(message, { variant, ...options });
  },
};
